import { useState } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import { GoCheck } from 'react-icons/go';
import { ACTIVE_NETWORKS, ChainId, NETWORK_LOGOS } from '@shared/utils/config/networks';
import classNames from '@/lib/misc/classNames';
import SlidingModal from '../home/mobile/SlidingModal';
import { getNetworkName, toSpecialFixed } from '@/lib/misc/utils';
import { TAssetModes } from './AssetsPortfolio';
import { ImageWithFallback } from '../shared/NextImageFallback';
interface PortfolioHeaderProps {
  showCashModal: boolean;
  setShowCashModal: (bol: boolean) => void;
  assetMode: TAssetModes;
  gotoNextAssetMode: () => void;
  isSwap?: boolean;
  assetData: any;
  desktop?: boolean;
  selectedNetwork: {
    name: string;
    value: string;
    logo: string;
  };
  setSelectedNetwork: (_: {
    name: string;
    value: string;
    logo: string;
  }) => void;
}
export const PortfolioHeader = ({
  showCashModal,
  setShowCashModal,
  assetMode,
  gotoNextAssetMode,
  assetData,
  desktop,
  selectedNetwork,
  setSelectedNetwork,
  isSwap
}: PortfolioHeaderProps) => {
  const networks = [{
    networkName: 'All Networks',
    totalUsdValue: assetData?.totalUsdValue,
    totalUsdRate: 100,
    chainId: 'all-networks'
  }, ...(assetData?.balancesByChain || []).map(chain => ({
    networkName: chain.networkName || 'Unknown Network',
    totalUsdValue: chain?.totalUsdValue,
    totalUsdRate: chain.totalUsdRate,
    chainId: chain.chainId,
    networkLogo: NETWORK_LOGOS[chain.chainId]
  }))].filter(x => ACTIVE_NETWORKS?.includes(x.chainId));
  const chainOrder = Object.values(ChainId);
  const getChainOrder = (chainId: any) => {
    const index = chainOrder.indexOf(chainId);
    return index !== -1 ? index : chainOrder.length;
  };
  const sortedNetworks = networks.sort((a, b) => {
    if (a.chainId === 'all-networks') return -1;
    if (b.chainId === 'all-networks') return 1;
    return getChainOrder(a.chainId) - getChainOrder(b.chainId);
  });
  const [isModalOpen, setModalOpen] = useState(false);
  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };
  const selectedNetworkName = selectedNetwork?.name;
  const selectedNetworkWithData = networks.find(network => network.networkName === selectedNetworkName);

  // const [secondsAgo, setSecondsAgo] = useState(0);
  // useEffect(() => {
  //   const id = setInterval(() => {
  //     const now = new Date();
  //     const lastFetched = new Date(lastFetchedPorftolio);
  //     const diff = Math.abs(now.getTime() - lastFetched.getTime());
  //     const seconds = Math.floor(diff / 1000);
  //     setSecondsAgo(seconds);
  //   }, 1000);
  //   //cleanup
  //   return () => {
  //     clearInterval(id);
  //   };
  // }, [lastFetchedPorftolio]);

  const totalCash = () => {
    let totalUsd = 0;
    if (assetData && assetData?.balances.length) {
      assetData.balances.map(token => {
        if (token.contract_ticker_symbol === 'USDC' || token.contract_ticker_symbol === 'USDT') {
          totalUsd += token.usd_value;
        }
      });
    }
    return totalUsd.toLocaleString(undefined, {
      maximumFractionDigits: 2
    });
  };
  return <>
      <div className='w-full text-genius-cream  flex items-center py-2 justify-start border-genius-blue border-y-[1px]'>
        <div onClick={() => setShowCashModal(false)} className={`flex items-center justify-between ${showCashModal ? 'text-genius-cream/50' : 'text-genius-cream'}  text-[20px] p-2 pl-4 cursor-pointer`}>
          <p>Crypto</p>
        </div>
        <div onClick={() => setShowCashModal(true)} className={`flex items-center justify-between text-genius-cream ${showCashModal ? 'text-genius-cream' : 'text-genius-cream/50'} text-[20px] p-2 cursor-pointer`}>
          <p>Cash</p>
        </div>
      </div>
      <div className='w-full bg-genius-blue text-genius-cream'>
        <div className={`py-3 px-4 w-full flex bg-genius-indigo ${isSwap && 'border-b-2 border-y-genius-blue'}`}>
          <div onClick={toggleModal} className={classNames('font-light w-2/4 cursor-pointer flex items-center', desktop && 'w-3/12')}>
            {selectedNetwork.logo && <ImageWithFallback src={selectedNetwork.logo} width={20} height={20} alt={`${selectedNetwork.name} logo`} className='mr-4' />}
            {getNetworkName(selectedNetwork.name)}
            <IoIosArrowDown className='h-4 w-4 ml-2' data-sentry-element="IoIosArrowDown" data-sentry-source-file="PortfolioHeader.tsx" />
            {/* {lastFetchedPorftolio ? (
             <div className='text-xs text-genius-cream/50 flex ml-2'>
              Updated{' '}
              {secondsAgo < 60 ? (
                <>{secondsAgo} seconds ago</>
              ) : (
                <>
                  {' '}
                  {new Date(lastFetchedPorftolio).toLocaleTimeString('en-US', {
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true,
                  })}
                </>
              )}
             </div>
             ) : (
             <></>
             )} */}
          </div>

          <div className={classNames('flex flex-col items-end w-2/4', desktop && 'w-5/12')}>
            <p className='flex items-center font-light'>
              {selectedNetworkWithData?.totalUsdValue && !isSwap ? showCashModal ? `$${totalCash()}` : `$${toSpecialFixed(selectedNetworkWithData?.totalUsdValue).value}` : ''}
            </p>
          </div>
        </div>
        {!isSwap && <div className='py-2 px-4 w-full flex'>
            <div className={classNames('w-5/12', desktop && 'w-3/12')}>
              <p>Asset</p>
            </div>
            {desktop && <div className='w-2/12'>
                <p>Price</p>
              </div>}
            <div onClick={gotoNextAssetMode} className={classNames('flex flex-col items-end w-full cursor-pointer pr-4')}>
              <p className='flex items-center justify-end'>
                {assetMode}
                <IoIosArrowDown className='h-4 w-4 ml-2' />
              </p>
            </div>
          </div>}

        <SlidingModal heightFit={true} isOpen={isModalOpen} onClose={toggleModal} data-sentry-element="SlidingModal" data-sentry-source-file="PortfolioHeader.tsx">
          <div className='pt-4'>
            <ul className='w-full'>
              {sortedNetworks.map(network => <li key={network.networkName || 'all-networks'} className='px-4 cursor-pointer md:hover:bg-genius-blue flex justify-between items-center py-3 border-genius-blue' onClick={() => {
              setSelectedNetwork({
                name: network.networkName || 'All Networks',
                value: `$${network?.totalUsdValue?.toFixed(2)}`,
                logo: network.networkLogo
              });
              toggleModal();
            }}>
                  <div className='flex items-center w-3/5'>
                    {network.networkLogo && <ImageWithFallback src={network.networkLogo} width={20} height={20} alt={`${network.networkName} logo`} className='mr-4 w-[20px] h-[20px]' />}
                    <span className='uppercase text-xs'>
                      {network.networkName === 'eth-mainnet' ? 'Ethereum' : network.networkName.replace('-mainnet', '')}
                    </span>
                    {selectedNetwork.name === network.networkName && <GoCheck className='h-4 w-4 ml-4' />}
                  </div>
                  <div className='flex items-end w-2/5 text-xs'>
                    <div className='flex-col w-3/4 ta-r pr-1'>
                      ${network?.totalUsdValue?.toFixed(2)}
                    </div>
                    <div className='flex-col w-3/4 text-genius-dark'>
                      ({network.totalUsdRate?.toFixed(2)}%)
                    </div>
                  </div>
                </li>)}
            </ul>
          </div>
        </SlidingModal>
      </div>
    </>;
};